
export default [
    {
		path: '/admin/game-prefixes',
		name: 'game-prefix',
		meta: { requiresAuth: true },
		component: () => import('@/pages/administrator/game-prefix')
    }
]